import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { loadFailureMessage, type ExpenseSupervisorAct } from '@evogard/domain';
import { SupervisorExpenseBoard } from '../../components/expense/SupervisorExpenseBoard.js';
import { api, ok } from '../../lib/api.js';
import { useSessionContext } from '../../lib/session.js';

const KEY = ['assistance', 'expenses'] as const;

/**
 * O quadro do supervisor da despesa da Assistência 24h (26/10/2026): o
 * fechamento do mês e o à vista, que nasce marcado como já pago e passa pelo
 * supervisor como os outros. Em `assistance.settlements:supervisionar_despesa`.
 *
 * Desde 02/11/2026 é a aba "Aprovação do supervisor" de Pagamentos, e não uma
 * tela própria: o dono achou confuso ter "Pagamentos" e "Despesas" lado a lado
 * no menu para o mesmo dinheiro em dois momentos.
 */
export function ApprovalBoard() {
  const { data: context } = useSessionContext();
  const client = useQueryClient();
  const board = useQuery({
    queryKey: [...KEY, context?.currentTenant.id],
    queryFn: async () =>
      ok(
        await api.assistanceExpenses.supervisorBoard(),
        200,
        loadFailureMessage(undefined, 'o quadro de despesas'),
      ),
  });
  const act = useMutation({
    mutationFn: async ({
      id,
      act,
      reason,
    }: {
      id: number;
      act: ExpenseSupervisorAct;
      reason: string | null;
    }) =>
      ok(
        await api.assistanceExpenses.supervisorAct({
          params: { id },
          body: { act, reason },
        }),
        200,
        'Não foi possível concluir.',
      ),
    onSettled: () => client.invalidateQueries({ queryKey: KEY }),
  });
  return (
    <SupervisorExpenseBoard
      label="Quadro de despesas da Assistência 24h"
      department="Assistência 24h"
      query={board}
      onAct={(id, a, reason) => act.mutateAsync({ id, act: a, reason })}
    />
  );
}
